// MenuShowcase.jsx
import {useState} from "react";
import { Cart } from "./Cart";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { menu } from "../data/dishes";
import ProductCard from "./ProductCard";

// ----- קומפוננטה -----
export default function MenuShowcase() {
  const { t } = useTranslation();

let menuData=[...menu];
 
  const [view, setView] = useState("cards"); // 'cards' | 'table'
  const [category,setCategory]= useState("");
  const categories = ["all", "Main-Dishs/עיקריות", "Side-Dishs/תוספות", "Soups/מרקים","Salads/סלטים", "Trays/מגשים","IsraeliProdact/מוצרים ישראלים"];
  const [cart,setCart] = useState(()=>{
      let  data = localStorage.getItem("cart");
      let  cartFromLocal= data? JSON.parse(data):[{total:0}]
      return (cartFromLocal)
    })
  const [menuToShow,setMenuToShow]= useState([...menuData])

function addToCart(prudact){
  let totali = cart[0].total+prudact.Price
  const existing = cart.find(item => item.name===prudact.name);
  cart.shift();
  let newCart;
  
  if(existing){
    newCart = cart.map(item=>
      item.name === prudact.name
      ? {...item ,quantity:item.quantity + 1}
      :item
    );
     toast.success(`${t("add_to_count_msg")}${totali}$`);
    
  }
  else{
    newCart=[...cart,{...prudact, quantity:1}]
       toast.success(`${t("add_to_cart_msg")}${totali}$`);
  }
  
  const total = newCart.reduce((sum , item)=> sum+item.Price*item.quantity,0)
  localStorage.setItem("cart",JSON.stringify([{total}, ...newCart]))
  setCart([{total}, ...newCart])
}



  return (
    <div className="container py-4" dir="rtl">
      {/* כותרת + בקרה */}
      <h2 className="m-0  text-center">{t("menu_title")}</h2>
      <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
     
        <div className="d-flex justify-content-center gap-2 mt-3 " >
          <div className="btn-group justify-content-center" style={{direction: "ltr"}} role="group" aria-label="view">
            <button
              className={`btn btn-outline-primary ${view === "cards" ? "active" : ""}`}
              onClick={() => setView("cards")}
            >
             {t("cards_view")}
            </button>
            <button
              className={`btn btn-outline-primary ${view === "table" ? "active" : ""}`}
              onClick={() => setView("table")}
            >
              {t("table_view")}
            </button>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-3">
         <select className="form-select text-center fw-bold" value={category}
         style={{
                maxWidth: "300px",borderRadius: "30px",borderWidth: "2px",borderColor: "#0d6efd",paddingInline: "1.5rem",backgroundColor: "#ffffff",color: "#0d6efd",boxShadow: "0 0 4px rgba(0, 0, 0, 0.1)",
    }} onChange={(e) =>
        {
          if(e.target.value==="all")
            {  
              setCategory(e.target.value)
              setMenuToShow([...menu]);
              return
            }
          else{          
            setCategory(e.target.value)
            const filterMenu = menu.filter((dish)=>
            dish.category===(e.target.value))
            setMenuToShow([...filterMenu])
          } 
        }
      }
    >
      { category===""?<option value="">{t("select_category")}</option>:null}
      {categories.map((cat) => (
        <option key={cat} value={cat}>
          {cat}
        </option>
      ))}
    </select>
      </div>
      
    
      {/* תצוגה */}
      {view === "cards" ? (
        <div className="row g-3" style={{opacity:"0.8"}}>
          {menuToShow.map((item, i) => (
            <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-3 pt-1">
            <ProductCard
                key={i}
                the_key={i} 
                imageSrc={item.img} 
                price={item.Price} 
                title={item[t("name_for_choose")]} 
                weight={item[t("quantity_f_s")]}
                buttonText={t("add_to_cart")}
                onAddToCart={()=>addToCart(item)}
                >
            </ProductCard>
            </div>
          ))}
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: "35%" }}>{t("name")}</th>
                <th style={{ width: "15%" }}>{t("quantity")}</th>
                <th style={{ width: "15%" }} className="text-end">{t("price ")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              
              {menuToShow.map((item, i) => (
                
                <tr key={i}>
                  <td>{item[t("name_for_choose")]}</td>
                  <td>
                    <span className="badge bg-light text-dark border">{item[t("quantity_f_s")]}</span>
                  </td>
                  <td className="text-end fw-semibold">${item.Price}</td>
                 <td><button className="btn btn-primary" onClick={()=>addToCart(item)}>{t("add_to_cart")} </button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <h4 className=" text-bg-light">{t("sale")}</h4>
            <div>
                <Cart thecart={cart} changeCart={setCart} ></Cart>
            </div>       
    </div>
  );
}
